module.exports = __webpack_public_path__ + "static/media/Silestone-Flash-Promo-Digital Flyer-Canada.4e58ee1d.pdf";